const NewsletterSubscribeFeedback = ({ formError, fieldError, isSuccess, successMessage }) => {
  if (formError) {
    return (
      <p className="newsletter-subscribe-feedback newsletter-subscribe-feedback--error" role="alert">
        {formError}
      </p>
    );
  }

  if (fieldError) {
    return (
      <p className="newsletter-subscribe-feedback newsletter-subscribe-feedback--error" role="alert">
        {fieldError}
      </p>
    );
  }

  if (isSuccess) {
    return (
      <p className="newsletter-subscribe-feedback newsletter-subscribe-feedback--success" role="status">
        {successMessage || 'Thank you for subscribing.'}
      </p>
    );
  }

  return null;
};

export default NewsletterSubscribeFeedback;
